import {
  Center,
  Container,
  Grid,
  Group,
  Image,
  Paper,
  Space,
  Text,
  Title,
  Tooltip,
} from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { Helmet } from 'react-helmet';
import { CircleCheck, Copy } from 'tabler-icons-react';
import useAuth from '../../hooks/useAuth';

function OnboardingPendingPage() {
  const { auth } = useAuth();
  const onboardingReferenceNumberClipboard = useClipboard();

  return (
    <>
      <Helmet>
        <title>XPAY.World - Pending</title>
      </Helmet>
      <Container
        fluid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper
          shadow='xl'
          style={{ maxWidth: 1000, borderRadius: 20 }}
          sx={{
            '@media (max-width: 755px)': {
              padding: 20,
              margin: 10,
            },
            '@media (min-width: 755px)': {
              padding: 100,
            },
            '@media (min-width: 1200px)': {
              padding: 150,
            },
          }}
        >
          <Grid justify='center'>
            <Grid.Col span={12}>
              <Center>
                <Image
                  style={{ maxWidth: 243, maxHeight: 193 }}
                  fit='contain'
                  src='/images/activation.svg'
                  alt='activation.svg'
                />
              </Center>
            </Grid.Col>
            <Grid.Col>
              <Title style={{ fontSize: '2rem' }} align='center'>
                Activation in progress
              </Title>
            </Grid.Col>
            <Grid.Col>
              <Space />
            </Grid.Col>
            <Grid.Col>
              <Text style={{ fontSize: '1rem' }} align='center'>
                Account activation is in progress! Thank you for submitting your
                documents, verification will take at least{' '}
                <strong>N days</strong>. Our team will notify you once all your
                documents are successfully verified.
              </Text>
            </Grid.Col>
            <Grid.Col>
              <Space />
            </Grid.Col>
            <Grid.Col>
              <Text style={{ fontSize: '1rem' }} align='center'>
                Our team will send an email to{' '}
                <span>
                  {auth?.email ? auth?.email : 'the email you used to register'}
                </span>{' '}
                once your account has been approved/activated or if there are
                any clarifications.
              </Text>
            </Grid.Col>
            {auth?.onboardingReferenceNumber && (
              <>
                <Grid.Col>
                  <Space />
                </Grid.Col>
                <Grid.Col>
                  <Text size='sm' align='center' color='gray'>
                    Reference Number:{' '}
                    <Tooltip
                      position='right'
                      placement='center'
                      gutter={13}
                      label={
                        onboardingReferenceNumberClipboard.copied ? (
                          <Group spacing={2}>
                            <CircleCheck size={18} strokeWidth={1.5} />
                            <Text size='sm'>Copied</Text>
                          </Group>
                        ) : (
                          <Group spacing={2}>
                            <Copy size={18} strokeWidth={1.5} />
                            <Text size='sm'>Click to copy</Text>
                          </Group>
                        )
                      }
                      withArrow
                      color={
                        onboardingReferenceNumberClipboard.copied
                          ? 'green'
                          : 'gray'
                      }
                    >
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          onboardingReferenceNumberClipboard.copy(
                            auth.onboardingReferenceNumber
                          )
                        }
                      >
                        {auth.onboardingReferenceNumber}
                      </span>
                    </Tooltip>
                  </Text>
                </Grid.Col>
              </>
            )}
          </Grid>
        </Paper>
      </Container>
    </>
  );
}

export default OnboardingPendingPage;
